<template>
  <div :class="$style.karte">
    <section :class="[$style.karte__userConcern, $style.topic]">
      <h3 :class="$style.topic__header">気になっていること</h3>
      <p v-if="karte.topics.length === 0" :class="$style.topic__notSelected">
        わからないので相談したい
      </p>
      <div v-else :class="$style.topic__list">
        <ul :class="$style.list">
          <li
            :class="$style.list__item"
            v-for="{ id, name } in karte.topics"
            :key="id"
          >
            <DolphinChip :text="name" :class="$style.topicItem" />
          </li>
        </ul>
      </div>
    </section>
    <section :class="[$style.karte__userConcern, $style.comment]">
      <h3 :class="$style.comment__header">
        選んだトピックの気になるところ（任意）
      </h3>
      <p :class="$style.comment__content">
        {{ comment }}
      </p>
    </section>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { type KarteUserConcernKarteFragment } from './KarteUserConcern.generated'
import DolphinChip from '../../atoms/DolphinChip.vue'

const props = defineProps<{
  karte: KarteUserConcernKarteFragment
}>()

const comment = computed(() =>
  props.karte.userComment === ''
    ? 'わからないので相談したい'
    : props.karte.userComment
)
</script>

<style lang="scss" module>
.karte {
  &__userConcern {
    &:nth-child(n + 2) {
      margin-top: 24px;
    }
  }
}

.topic {
  &__notSelected {
    margin-left: 1em;

    &:nth-child(n + 2) {
      margin-top: 4px;
    }
  }

  &__list {
    &:nth-child(n + 2) {
      margin-top: 16px;
    }
  }
}

.list {
  display: flex;
  flex-wrap: wrap;
  margin: -8px 0 0 -8px;

  &__item {
    margin: 8px 0 0 8px;
  }
}

.topicItem {
  color: $color-text-and-object-high-emphasis;
  background-color: $color-surface-secondary;
}

.comment {
  &__content {
    &:nth-child(n + 2) {
      margin-top: 16px;
    }
  }
}
</style>
